import React from 'react';

const WorkOrderStep2Equipment = ({ formData, setFormData, formErrors, machines, plants, lines }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      
      // Auto-populate fields when machine is selected
      if (name === 'machineId' && value) {
        const machine = machines.find(m => m.machineId === parseInt(value, 10));
        if (machine) {
          updated.equipmentCode = machine.machineCode || '';
          updated.serialNumber = machine.serialNo || '';
          updated.lineId = machine.lineId?.toString() || '';
          
          // Find plant from line
          if (machine.lineId) {
            const line = lines.find(l => l.lineId === machine.lineId);
            if (line) {
              updated.plantId = line.plantId?.toString() || '';
            }
          }
        }
      }
      
      // Reset cascading fields
      if (name === 'plantId') {
        updated.lineId = '';
        updated.machineId = '';
        if (value) {
          localStorage.setItem('defaultPlantId', value);
        }
      } else if (name === 'lineId') {
        updated.machineId = '';
      }
      
      return updated;
    });
  };

  const filteredLines = formData.plantId
    ? lines.filter(l => l.plantId?.toString() === formData.plantId)
    : lines;
    
  const filteredMachines = formData.lineId
    ? machines.filter(m => m.lineId?.toString() === formData.lineId)
    : machines;

  return (
    <div className="step-form">
      <div className="form-section">
        <h3 className="section-title">Equipment Selection</h3>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="plantId">Plant</label>
            <select
              id="plantId"
              name="plantId"
              value={formData.plantId}
              onChange={handleChange}
            >
              <option value="">Select Plant</option>
              {plants.map(plant => (
                <option key={plant.plantId} value={plant.plantId}>
                  {plant.plantName}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="lineId">Line / Area</label>
            <select
              id="lineId"
              name="lineId"
              value={formData.lineId}
              onChange={handleChange}
              disabled={!formData.plantId}
            >
              <option value="">Select Line</option>
              {filteredLines.map(line => (
                <option key={line.lineId} value={line.lineId}>
                  {line.lineName}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="machineId">Machine / Equipment <span className="required">*</span></label>
            <select
              id="machineId"
              name="machineId"
              value={formData.machineId}
              onChange={handleChange}
              className={formErrors.machineId ? 'error' : ''}
              disabled={!formData.lineId}
            >
              <option value="">Select Machine</option>
              {filteredMachines.map(machine => (
                <option key={machine.machineId} value={machine.machineId}>
                  {machine.machineName} ({machine.machineCode})
                </option>
              ))}
            </select>
            {formErrors.machineId && <span className="field-error">{formErrors.machineId}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="equipmentCode">Equipment Code</label>
            <input
              type="text"
              id="equipmentCode"
              name="equipmentCode"
              value={formData.equipmentCode}
              onChange={handleChange}
              readOnly
              className="readonly"
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="assetCategory">Asset Category</label>
            <input
              type="text"
              id="assetCategory"
              name="assetCategory"
              value={formData.assetCategory}
              onChange={handleChange}
              placeholder="Press, CNC, Chiller, Utility, etc."
            />
          </div>
          <div className="form-group">
            <label htmlFor="serialNumber">Serial Number / Tag Number</label>
            <input
              type="text"
              id="serialNumber"
              name="serialNumber"
              value={formData.serialNumber}
              onChange={handleChange}
              readOnly
              className="readonly"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderStep2Equipment;

